import React, { useState, useEffect } from 'react';

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'all');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookiesAccepted', 'essential-only');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={bannerStyle}>
      <div style={contentStyle}>
        <div style={textContainerStyle}>
          <p style={textStyle}>
            <strong>🍪 कुकीज / Cookies</strong>
            <br />
            <span style={{ fontSize: '0.9rem' }}>
              आम्ही तुमचा अनुभव सुधारण्यासाठी आवश्यक कुकीज वापरतो आणि{' '}
              <strong>Google Analytics (GA4)</strong> द्वारे वापर पद्धती समजून घेतो.
            </span>
            <br />
            <span style={{ fontSize: '0.85rem', color: '#ccc' }}>
              We use essential cookies to operate the platform and{' '}
              <strong>Google Analytics 4</strong> (an analytics service by Google LLC, USA) to
              understand usage patterns. Analytics data is processed on Google's servers in the
              United States. See our{' '}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>
                Privacy Policy
              </a>{' '}
              for details.
            </span>
          </p>
        </div>
        <div style={buttonGroupStyle}>
          <button onClick={handleAccept} style={acceptButtonStyle}>
            ✓ सर्व स्वीकार / Accept All
          </button>
          <button onClick={handleDecline} style={declineButtonStyle}>
            केवळ आवश्यक / Essential Only
          </button>
        </div>
      </div>
    </div>
  );
}

// Styles
const bannerStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#2c3e50',
  color: '#fff',
  padding: '1rem 1.5rem',
  boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.2)',
  zIndex: 10000,
  animation: 'slideUp 0.3s ease-out'
};

const contentStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '1.5rem',
  flexWrap: 'wrap'
};

const textContainerStyle = {
  flex: 1,
  minWidth: '250px'
};

const textStyle = {
  margin: 0,
  lineHeight: '1.6',
  fontSize: '0.95rem'
};

const linkStyle = {
  color: '#64b5f6',
  textDecoration: 'underline',
  fontWeight: '600'
};

const buttonGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flexShrink: 0,
};

const acceptButtonStyle = {
  backgroundColor: '#4caf50',
  color: '#fff',
  border: 'none',
  padding: '0.7rem 1.8rem',
  borderRadius: '6px',
  fontSize: '0.95rem',
  fontWeight: '700',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'background-color 0.3s',
  boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
};

const declineButtonStyle = {
  backgroundColor: 'transparent',
  color: '#ccc',
  border: '1px solid #666',
  padding: '0.6rem 1.8rem',
  borderRadius: '6px',
  fontSize: '0.9rem',
  fontWeight: '600',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  transition: 'border-color 0.3s',
};

export default CookieBanner;
